import { render, staticRenderFns } from "./FaQAbout.html?vue&type=template&id=949f61b0&scoped=true&"
import script from "./FaQAbout.ts?vue&type=script&lang=ts&"
export * from "./FaQAbout.ts?vue&type=script&lang=ts&"
import style0 from "./FaQAbout.css?vue&type=style&index=0&id=949f61b0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949f61b0",
  null
  
)

export default component.exports